import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FormatListUnordered = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M6.5 15c0.83 0 1.5 0.672 1.5 1.5s-0.67 1.5-1.5 1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5zM6.5 7c0.83 0 1.5 0.672 1.5 1.5s-0.67 1.5-1.5 1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5zM6.5 23c0.83 0 1.5 0.672 1.5 1.5s-0.67 1.5-1.5 1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5zM12 9.5c-0.552 0-1-0.448-1-1 0-0.553 0.448-1 1-1h14c0.552 0 1 0.447 1 1 0 0.552-0.448 1-1 1h-14zM26 15.5c0.553 0 1 0.447 1 1s-0.447 1-1 1h-14c-0.552 0-1-0.447-1-1s0.448-1 1-1h14zM26 23.5c0.552 0 1 0.447 1 1s-0.448 1-1 1h-14c-0.552 0-1-0.447-1-1s0.448-1 1-1h14z" />
  </SvgIcon>
);

export default FormatListUnordered;
